<div class="dismount-button">
  <span class="dismount-button__text">{{ 'DISMOUNTING.DISMOUNT' | translate }}</span>
  <lib-dismount-button class="dismount-button__counter" [dismountableCount]="dismountableCount"></lib-dismount-button>
</div>
